// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__fsLZi","selects":"Documents_selects__3VRLA"};